import { render, staticRenderFns } from "./SecondOpinion.vue?vue&type=template&id=0b40d534&scoped=true"
import script from "./SecondOpinion.vue?vue&type=script&lang=js"
export * from "./SecondOpinion.vue?vue&type=script&lang=js"
import style0 from "./SecondOpinion.vue?vue&type=style&index=0&id=0b40d534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40d534",
  null
  
)

export default component.exports